import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LoadingComponent } from './components/loading/loading.component';
import { SelectSearchPipe } from './pipes/select-search.pipe';
import { MaterialModule } from "./material.module";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ReactiveFormsModule } from "@angular/forms";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';
import { ClickStopPropagationDirective } from "./directives/click-stop-propagation.directive";
import { InputCurrencyNumberDirective } from "./directives/input-currency-number.directive";
import { InputTextDirective } from "./directives/input-text.directive";
import { InputZipCodeDirective } from "./directives/input-zip-code.directive";
import { TooltipModule } from "@amin-karimi/ng2-tooltip-directive";
import { EmailValidatorDirective } from "./directives/email-validator.directive";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CustomDatePickerComponent } from './components/custom-date-picker/custom-date-picker.component';
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { BreadcrumbComponent } from "./components/breadcrumb/breadcrumb.component";
import { ShipmentListDetailComponent } from "./components/shipment-list-detail/shipment-list-detail.component";
import { UpdateFormComponent } from "./components/update-form/update-form.component";
import { RouterModule } from "@angular/router";
import { NgxFileDragDropComponent } from "ngx-file-drag-drop";
import { UploadFileDialogComponent } from "./components/upload-file-dialog/upload-file-dialog.component";
import { InputAlphanumericDirective } from "./directives/input-alphanumeric.directive";
import { EdiFileDialogComponent } from "./components/edi-file-dialog/edi-file-dialog.component";
import { SectionTitleComponent } from "./components/section-title/section-title.component";
import { CustomerSelectComponent } from "./components/customer-select/customer-select.component";
import { Ng2SearchPipe } from './pipes/ng2-search-search.pipe';
import { FilterChunkPipe } from './pipes/filter-chunk.pipe';
import { InfoCardComponent } from './components/info-card/info-card.component';
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { HeaderComponent } from "../navigation/header/header.component";
import { TextComparisonComponent } from "./components/text-comparison/text-comparison.component";
import { AutoUpperCaseDirective } from "./directives/auto-upper-case.directive";
import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { InternalReviewDialogComponent } from '../shipment-master/shipment-details/shipment-actions/internal-review-dialog/internal-review-dialog.component';
import { ManualBenchmarkDialogComponent } from '../shipment-master/shipment-details/shipment-actions/manual-benchmark-dialog/manual-benchmark-dialog.component';
import { PreprogramDialogComponent } from '../shipment-master/shipment-details/shipment-actions/preprogram-dialog/preprogram-dialog.component';
import { ClipboardCopyDirective } from './directives/clipboard-copy.directive';
import { ImperiaSelectComponent } from './components/imperia-select/imperia-select.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';

@NgModule({
  declarations: [
    LoadingComponent,
    SelectSearchPipe,
    ClickStopPropagationDirective,
    InputCurrencyNumberDirective,
    InputTextDirective,
    InputZipCodeDirective,
    InputAlphanumericDirective,
    EmailValidatorDirective,
    CustomDatePickerComponent,
    ConfirmDialogComponent,
    BreadcrumbComponent,
    ShipmentListDetailComponent,
    UpdateFormComponent,
    UploadFileDialogComponent,
    EdiFileDialogComponent,
    SectionTitleComponent,
    CustomerSelectComponent,
    InfoCardComponent,
    HeaderComponent,
    TextComparisonComponent,
    AutoUpperCaseDirective,
    Ng2SearchPipe,
    FilterChunkPipe,
    FeatureFlagDirective,
    InternalReviewDialogComponent,
    ManualBenchmarkDialogComponent,
    PreprogramDialogComponent,
    ClipboardCopyDirective,
    ImperiaSelectComponent,
    FileViewerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FlexLayoutModule,
    NgxChartsModule,
    NgxMatSelectSearchModule,
    TooltipModule,
    ReactiveFormsModule,
    ScrollingModule,
    ExperimentalScrollingModule,
    NgxFileDragDropComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxExtendedPdfViewerModule
  ],
  exports: [
    LoadingComponent,
    FlexLayoutModule,
    MaterialModule,
    SelectSearchPipe,
    NgxChartsModule,
    NgxMatSelectSearchModule,
    TooltipModule,
    ReactiveFormsModule,
    ScrollingModule,
    ExperimentalScrollingModule,
    ClickStopPropagationDirective,
    InputCurrencyNumberDirective,
    InputTextDirective,
    InputZipCodeDirective,
    InputAlphanumericDirective,
    EmailValidatorDirective,
    NgxMaskDirective,
    NgxMaskPipe,
    CustomDatePickerComponent,
    ConfirmDialogComponent,
    BreadcrumbComponent,
    ShipmentListDetailComponent,
    UpdateFormComponent,
    NgxFileDragDropComponent,
    UploadFileDialogComponent,
    EdiFileDialogComponent,
    SectionTitleComponent,
    CustomerSelectComponent,
    InfoCardComponent,
    HeaderComponent,
    TextComparisonComponent,
    AutoUpperCaseDirective,
    Ng2SearchPipe,
    FilterChunkPipe,
    FeatureFlagDirective,
    InternalReviewDialogComponent,
    ManualBenchmarkDialogComponent,
    PreprogramDialogComponent,
    ClipboardCopyDirective,
    ImperiaSelectComponent,
    FileViewerComponent
  ],
  providers: [
    DatePipe,
    provideNgxMask()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
